module.exports = __webpack_public_path__ + "media/images/logo-green-main-5929d39c.png";